import React from "react";

import Icon from "assets/BGC-note-done.svg";
import BGCInfoPage from "./BGCInfoPage";

const PageTwo: React.FC = () => (
  <BGCInfoPage
    icon={Icon}
    iconAlt="BGC assessment checklist icon"
    heading="What will I do in the BGC Next App?"
  >
    You will complete 4 cognitive tasks related to working memory, executive
    function, and attention. This should take about 20 minutes. That&apos;s it!
  </BGCInfoPage>
);

export default PageTwo;
